<!--
  - Copyright (c) 2023-2025. Haodong JU
  -->

<template>
  <div
    v-if="(currentState===-1&&inNew)||(currentState>-1&&inEdit)"
  >
    <div
      v-if="type.name!=='image'&&text&&!hideSelect"
      class="pb-1"
    >
      <div class="text-caption">
        {{ $t(text) }}
        <span
          v-if="text&&required&&!hideSelect"
          class="red--text text-body-1"
        >*</span>
      </div>
      <template v-if="hint">
        <div class="text-caption text--secondary">
          {{ $t(hint) }}
        </div>
      </template>
    </div>
    <template v-if="type.name==='text'">
      <v-text-field
        v-if="!textArea"
        v-model="editedItem[value]"
        :disabled="shouldDisable"
        :rules="rules"
        outlined
      />
      <v-textarea
        v-else
        v-model="editedItem[value]"
        :counter="maxLength||''"
        :disabled="shouldDisable"
        :rules="rules"
        auto-grow
        outlined
        rows="1"
      />
    </template>
    <template v-if="type.name==='description'">
      <v-text-field
        v-if="!textArea"
        v-model="editedItem[value]"
        :disabled="shouldDisable"
        :rules="rulesByDesc"
        outlined
      />
      <v-textarea
        v-else
        v-model="editedItem[value]"
        :counter="maxLength||''"
        :disabled="shouldDisable"
        :rules="rulesByDesc"
        auto-grow
        outlined
        rows="1"
      />
    </template>
    <template v-if="type.name==='float'">
      <v-text-field
        v-model="editedItem[value]"
        :disabled="shouldDisable"
        :rules="rules"
        outlined
        step="0.01"
        type="number"
      >
        <!--                <template #append>€</template>-->
      </v-text-field>
    </template>
    <template v-if="type.name==='integer'">
      <v-text-field
        v-model="editedItem[value]"
        :disabled="shouldDisable"
        :rules="rules"
        outlined
        step="1"
        type="number"
      />
    </template>
    <template v-else-if="type.name==='select'">
      <v-select
        v-model="editedItem[value]"
        :clearable="hideSelect"
        :disabled="shouldDisable"
        :item-text="type.itemText"
        :item-value="type.itemValue"
        :items="selectItemList"
        :menu-props="{offsetY:true, outlined:true, contentClass:'elevation-2 ikRounded',
                      nudgeBottom:'16px',closeOnContentClick: !type.multiple,}"
        :multiple="type.multiple"
        :placeholder="text"
        :rules="rules"
        outlined
        @click:clear="$emit('clear')"
      >
        <template
          v-if="type.showButton&&!hideSelect"
          #prepend-item
        >
          <v-list-item @click="$emit('click')">
            <v-list-item-content>
              <v-list-item-title class="primary--text">
                {{ $t('NewOthers') }} {{ text }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider />
        </template>
        <template
          v-if="hideSelect"
          #selection="{ item, index }"
        >
          <span
            v-if="index==0"
            class="grey--text text-caption"
          >
            {{ $t(text) }}({{ showText(item) }})
          </span>
        </template>
      </v-select>
    </template>
    <template v-else-if="type.name==='switch'">
      <v-select
        v-model="editedItem[value]"

        :clearable="hideSelect"
        :disabled="shouldDisable"
        :items="[{text:$t('yes'),value:true},{text:$t('no'),value:false}]"
        :menu-props="{offsetY:true, outlined:true, contentClass:'elevation-2 ikRounded',
                      nudgeBottom:'16px',closeOnContentClick: !type.multiple,}"
        :placeholder="$t(text)"
        :rules="rules"
        outlined
        @click:clear="$emit('clear')"
      />
    </template>
    <template v-else-if="type.name==='image'">
      <div class="d-flex flex-column align-center">
        <v-card
          class="d-flex justify-center align-center"
          color="#eeeeee"
          flat
          height="160px"
          width="160px"
          @click="startUpload"
        >
          <img-with-loading
            v-if="editedItem[type.fileStorage]"
            :height="'160px'"
            :img-src="uploadUrl"
          />
          <template
            v-else-if="currentState>-1"
          >
            <img-with-loading
              :height="'160px'"
              :img-src="root + editedItem[value]"
            />
          </template>
          <v-btn
            absolute
            bottom
            color="primary"
            fab
            style="right: -12px"
            x-small
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-card>
        <v-file-input
          ref="file"
          v-model="fileStore"
          :disabled="shouldDisable"
          :hide-details="noDetails"
          :label="$t(text)"
          :placeholder="$t(text)"
          :rules="rules"
          accpet="image/*"
          class="mt-2"
          counter
          dense
          outlined
          prepend-icon=""
          prepend-inner-icon="mdi-file"
          show-size
          style="height: 0;opacity: 0"
        />
        <div class="text-caption text--secondary">
          {{ $t(hint) }}
        </div>
      </div>
    </template>
    <template v-else-if="type.name==='time'">
      <v-dialog
        ref="dialog"
        v-model="timePickerShow"
        :return-value.sync="editedItem[value]"
        persistent
        width="290px"
      >
        <template #activator="{ on }">
          <div>
            <v-text-field
              v-model="editedItem[value]"
              outlined
              prepend-inner-icon="mdi-clock-outline"
              readonly
              v-on="on"
            />
          </div>
        </template>
        <v-time-picker
          v-if="timePickerShow"
          v-model="editedItem[value]"
          full-width
        >
          <v-spacer />
          <v-btn
            color="primary"
            text
            @click="timePickerShow = false"
          >
            {{ $t('Cancel') }}
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="$refs.dialog.save(editedItem[value])"
          >
            {{ $t('OK') }}
          </v-btn>
        </v-time-picker>
      </v-dialog>
    </template>
    <template v-else-if="type.name==='date'">
      <v-dialog
        ref="dialog"
        v-model="datePickerShow"
        :return-value.sync="editedItem[value]"
        persistent
        width="290px"
      >
        <template #activator="{ on }">
          <v-text-field
            v-model="editedItem[value]"
            outlined
            prepend-inner-icon="mdi-calendar"
            readonly
            v-on="on"
          />
        </template>
        <v-date-picker
          v-if="datePickerShow"
          v-model="editedItem[value]"
          :locale="locale"
          full-width
        >
          <v-spacer />
          <v-btn
            color="primary"
            text
            @click="datePickerShow = false"
          >
            {{ $t('Cancel') }}
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="$refs.dialog.save(editedItem[value])"
          >
            {{ $t('OK') }}
          </v-btn>
        </v-date-picker>
      </v-dialog>
    </template>
    <template v-else-if="type.name==='color'">
      <v-item-group
        v-model="editedItem[value]"
        mandatory
      >
        <div
          style="display: grid;
        grid-template-columns: repeat(auto-fill,48px);
        grid-gap: 4px;"
        >
          <v-item
            v-for="color in colorList"
            :key="color"
            v-slot="{active,toggle}"
            :value="color"
          >
            <v-card
              :color="color"
              class="d-flex align-center justify-center"
              height="48px"
              width="48px"
              @click="toggle"
            >
              <v-icon v-if="active">
                mdi-check
              </v-icon>
            </v-card>
          </v-item>
        </div>
      </v-item-group>
    </template>
    <template v-else>
      <slot />
    </template>
  </div>
</template>

<script>
import ImgWithLoading from './Base/ImgWithLoading.vue'
import imageCompression from 'browser-image-compression'

export const colorList = [
  '#FFCDD2', '#F8BBD0', '#E1BEE7',
  '#D1C4E9', '#C5CAE9', '#BBDEFB',
  '#B3E5FC', '#B2EBF2', '#B2DFDB',
  '#C8E6C9', '#DCEDC8', '#F0F4C3',
  '#FFF9C4', '#FFECB3', '#FFE0B2',
  '#FFCCBC', '#D7CCC8', '#CFD8DC',
  '#FFFFFF'
]

const noSpecialCharRule = v => typeof v !== 'string' || (!v || !/[',"]/g.test(v) || this.$t('FormRulesHint'))

const noSpecialCharRuleWithoutComma = v => typeof v !== 'string' || (!v || !/['"]/g.test(v) || this.$t('FormRulesHint2'))

export function getColorLightness (c) {
  if (c?.startsWith('#')) {
    if (c.length < 5) {
      c += 'fff'
    }
    const rgb = parseInt(c.substring(1), 16) // convert rrggbb to decimal
    const r = (rgb >> 16) & 0xff // extract red
    const g = (rgb >> 8) & 0xff // extract green
    const b = (rgb >> 0) & 0xff // extract blue
    return 0.2126 * r + 0.7152 * g + 0.0722 * b
  } else {
    return 0
  }
}

export default {
  name: 'FormField',
  components: { ImgWithLoading },
  props: {
    field: {
      type: Object,
      default: () => {
      }
    },
    editedItem: {
      type: Object,
      default: () => {
      }
    },
    currentState: {
      type: Number,
      default: -1
    },
    noDetails: {
      type: Boolean,
      default: false
    },
    onToolbar: {
      type: Boolean,
      default: false
    },
    fullHeight: { default: false },
    hideSelect: { default: false },
    solo: { default: false },
    outsideDisabled: { default: false }
  },
  data: function () {
    return {
      fileStore: null,
      colorList,
      timePickerShow: false,
      datePickerShow: false,
      textArea: false,
      hint: '',
      ...this.field
    }
  },
  computed: {
    selectItemsIsDynamic: function () {
      return typeof this?.type?.selectItems === 'function'
    },
    selectItemList: function () {
      let selectItems = []
      const post = (items) => {
        let result = []
        if (typeof this.type.disabledItem === 'function') {
          result = items.map((item) => this.type.disabledItem(item, this.editedItem))
        } else {
          result = items.map(item => ({
            ...item,
            disabled: false
          }))
        }
        return result
      }

      if (this.selectItemsIsDynamic) {
        selectItems = this.type._selectItems ? this.type._selectItems : []
      } else {
        selectItems = this.type.selectItems
      }
      selectItems = post(selectItems)
      return selectItems
    },
    uploadUrl: function () {
      return URL.createObjectURL(this.editedItem[this.type.fileStorage])
    },
    isNew: function () {
      return this.currentState === -1
    },
    shouldDisable: function () {
      return this.outsideDisabled ||
          (this.disableNew && this.isNew) ||
          (this.disableEdit && !this.isNew)
    },
    rules: function () {
      let rules = [...this.rule]
      if (this.required && this.type.name !== 'switch') {
        if (!this.overwriteRule) {
          if (this.isNew && this.requiredNew) {
            rules = rules.concat([v => !!v || this.$i18n.t('cantBeEmpty')])
          } else if (!this.isNew && this.requiredEdit) {
            rules = rules.concat([v => !!v || this.$i18n.t('cantBeEmpty')])
          }
        }
      }
      rules.push(noSpecialCharRule)
      return this.hideSelect ? [] : rules
    },
    rulesByDesc: function () {
      let rules = [...this.rule]
      if (this.required && this.type.name !== 'switch') {
        if (!this.overwriteRule) {
          if (this.isNew && this.requiredNew) {
            rules = rules.concat([v => !!v || this.$i18n.t('cantBeEmpty')])
          } else if (!this.isNew && this.requiredEdit) {
            rules = rules.concat([v => !!v || this.$i18n.t('cantBeEmpty')])
          }
        }
      }
      rules.push(noSpecialCharRuleWithoutComma)
      return this.hideSelect ? [] : rules
    },
    locale: function () {
      const locale = this.dateLocale
      return locale
    },
    root: function () {
      return typeof this.type.root === 'function' ? this.type.root() : this.type.root
    }
  },
  watch: {
    editedItem: {
      deep: true,
      handler: function (val) {
        // console.log("type flag 3 editedItem",this.editedItem)
        this.preProcessOptions()
      }
    },
    async fileStore (val) {
      const options = {
        maxSizeMB: 1,
        useWebWorker: true
      }
      this.$set(this.editedItem, this.type.fileStorage, await imageCompression(val, options))
    }
  },
  mounted () {
    this.preProcessOptions()
  },
  methods: {
    showText (item) {
      const value = this.editedItem[this.value]
      return Array.isArray(value) ? '+' + value.length : item[this.type.itemText]
    },
    startUpload () {
      this.$refs.file.$refs.input.click()
    },
    colorIsDark (color) {
      return getColorLightness(color) < 128
    },
    async preProcessOptions () {
      // console.log("type flag 2")
      if (this.selectItemsIsDynamic) {
        if (this.type.selectItems().then) {
          const res = await this.type.selectItems()
          this.$set(this.type, '_selectItems', res)
        } else {
          this.$set(this.type, '_selectItems', this.type.selectItems())
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
